<template lang="pug">
  b-modal(v-model="isBusy" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer)
    .loading-msg
      b-spinner.spinner
      span.message.align-self-center {{ message }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### ローディング表示コンポーネント
 */
@Component
export default class Loading extends Vue {
  /** ローディングの表示 */
  @Prop({
    required: true
  })
  isBusy!: boolean;
  /** 表示メッセージ */
  @Prop({
    default: () => {
      return "読込み中";
    }
  })
  message!: string;
}
</script>

<style lang="scss" scoped>
@import "../../styles/mobile/_colors.scss";

.loading-msg {
  text-align: center;
  padding: 2rem 0;
  .spinner {
    color: $loding-spinner;
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }
  .message {
    color: $font-base;
    font-size: 1.5rem;
    font-weight: bold;
  }
}
</style>
